module.exports = __webpack_public_path__ + "img/zyjy_03.53ecbf54.png";